/* eslint-disable */
// Generated by scripts/generate-merch-images.mjs. Do not edit by hand.

import img0 from 'url:../assets/merch/cheap-patches/slava-ukraine-fundraiser.jpg'
import img1 from 'url:../assets/merch/patches/fuck-putin.jpg'
import img2 from 'url:../assets/merch/patches/scotland-ukraine.jpg'
import img3 from 'url:../assets/merch/patches/scottish-metal-fundraiser.jpg'
import img4 from 'url:../assets/merch/patches/stand-with-ukraine.jpg'
import img5 from 'url:../assets/merch/patches/ukraine-crest.jpg'
import img6 from 'url:../assets/merch/glasses/ukraine-trident.jpg'
import img7 from 'url:../assets/merch/glasses/ukraine-metal-trident.jpg'
import img8 from 'url:../assets/merch/glasses/ukraine-metal-trident-3.jpg'
import img9 from 'url:../assets/merch/t-shirt/metal-for-ukraine.jpg'
import img10 from 'url:../assets/merch/doll-10cm/ukrainian-doll-small.jpg'
import img11 from 'url:../assets/merch/doll-15cm/ukrainian-doll-big.jpg'

export const merchImagesByProduct: Record<string, string[]> = {
  'patch-slava-ukraine-fundraiser': [img0],
  'patch-fuck-putin': [img1],
  'patch-scotland-ukraine': [img2],
  'patch-scottish-metal-fundraiser': [img3],
  'patch-stand-with-ukraine': [img4],
  'patch-ukraine-crest': [img5],
  'glass-1': [img6],
  'glass-2': [img7],
  'glass-3': [img8],
  't-shirt': [img9],
  'doll-10cm': [img10],
  'doll-15cm': [img11],
}
